
import PolicyInfo from "./PolicyInfo.vue";
import PaymentInfo from "./PaymentInfo.vue";
import Footer from "./quickPayFooter.vue";
import { Tabs, TabPane } from "element-ui";
import VueWithMixins from "@/helpers/mixins";
import QuickPayMixin from "./QuickPayMixin";
import { authMapState } from "@/store/modules/auth";

export default VueWithMixins(QuickPayMixin).extend({
  components: {
    PolicyInfo,
    PaymentInfo,
    "el-tabs": Tabs,
    "el-tab-pane": TabPane,
    Footer
  },
  data() {
    return {
      plugin: {} as HTMLScriptElement,
      date: "",
      modalName: "quickPayModal",
      allowPayment: true,
      isInUS: false
    };
  },
  async mounted() {
    this.$nextTick(async () => {
      this.checkEmergency();
      this.allowPayment = true; /*this.checkBrowserSupport();*/
      if (this.allowPayment) {
        this.isInUS = await this.userIsInUS();
        if (!this.isInUS) {
          this.geoLocationError();
        }
      }
    });

    //temporary fix
    const quickpayMain = document.querySelector(".quickpay--main") as any;
    if (quickpayMain.parentNode)
      quickpayMain.parentNode.classList.remove("wrap");

    const { quickPayEmergencyModeMessage = "" } = this.initData || {};
    const actualQuickPayEmergencyMode = Boolean(quickPayEmergencyModeMessage);
    const isInEmergencyMode = actualQuickPayEmergencyMode || this.tempEmergency;
    const defaultMessage =
      "Payment system down for emergency maintenance. Please try again later";

    const emergencyModeMessage = actualQuickPayEmergencyMode
      ? quickPayEmergencyModeMessage
      : defaultMessage;
    if (isInEmergencyMode) {
      this.$router.push({
        path: `/403`,
        query: {
          message: emergencyModeMessage
        }
      });
    }
  },
  methods: {
    handleShowModal($event: any) {
      this.showModal({ ...$event, modalName: "quickPayModal" });
    },

    showPaidInFullModal() {
      this.modalDetails.title = "Policy paid in full";
      this.modalDetails.description =
        "This policy is paid in full. If you have further questions,please call our billing department at 888-786-0003 or email Billing at AtlasBilling@AtlasGeneral.com";
      this.$modal.show("quickPayModal");
    },
    showMinimumAmountDueModal(date: string) {
      this.modalDetails.title = "Payment past due";
      this.modalDetails.description = `Payment past due – Policy will lapse unless the minimum due amount is received by ${date}`;
      this.$modal.show("quickPayModal");
    },
    gotoNext(policyInfo: any) {
      this.activeTabName = "pay";

      this.$nextTick(() => {
        const paymentTab = this.$refs.paymentTab as any;
        const fieldRef = paymentTab?.field_currentAmountDue;
        if (fieldRef && fieldRef.$el) {
          const fieldRefInput = fieldRef.$el.querySelector("input");
          fieldRefInput.focus();
        }
      });
      const status = policyInfo.Summary.PolicyStatus;
      const date = policyInfo.Summary.ComputedCancellationDt;
      if (status === "P") {
        this.showPaidInFullModal();
      } else if (status == "C") {
        this.showMinimumAmountDueModal(date);
      }
    },
    gotoPrevious() {
      this.activeTabName = "inquiry";
    }
  },
  computed: {
    ...authMapState(["initData"]),
    initWithBillPayData(): boolean {
      return !!(
        this.$route.query.prefix &&
        this.$route.query.policyNumber &&
        this.$route.query.companyNumber
      );
    }
  }
});
